interface ProfileSnapshot {
  age?: number;
  isMarketingConsented: boolean;
}

export type AutoCheckInEvaluation = 'wait-for-consent' | 'stop' | 'proceed';

export const resolveAutoCheckInEvaluation = ({
  age,
  isMarketingConsented,
}: ProfileSnapshot): AutoCheckInEvaluation => {
  if (age === undefined || age < 19) {
    return 'stop';
  }

  if (!isMarketingConsented) {
    return 'wait-for-consent';
  }

  return 'proceed';
};

interface AttendanceSnapshot {
  alreadyCheckedToday: boolean;
  buttonState: 'CHECK' | 'RESTART' | 'DONE';
}

//* RESTART(1일부터 다시하기)는 자동 발사하지 않는다 — 사이클 재시작은 사용자 의사가
//* 개입해야 하는 프로덕트 결정이라 수동 경로에만 둔다.
export const shouldFireAutoCheckIn = ({
  alreadyCheckedToday,
  buttonState,
}: AttendanceSnapshot): boolean =>
  !alreadyCheckedToday && buttonState === 'CHECK';
